import React, { useEffect, useState } from 'react';
import { getDept, getDepts, updateDept } from '../../api/deptApi';

function DeptEdit({ code, comCode, comName, onCancel, onUpdated  }) {
  const [form, setForm] = useState({
    dept_name: '',
    parent_dept_code: '',
    parent_dept_name: '',
    manager_userid: '',
    sort_order: 0,
  });
  const [deptList, setDeptList] = useState([]);

  useEffect(() => {
    if (!comCode) return;

    getDept(code, comCode).then(res => {
      const { dept_name, parent_dept_code, parent_dept_name, manager_userid, sort_order } = res.data;
      setForm({ dept_name, parent_dept_code, parent_dept_name, manager_userid, sort_order });
    });

    getDepts(comCode).then(res => {
      setDeptList(res.data.filter(d => d.dept_code !== code));
    });
  }, [code, comCode]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleParentChange = (e) => {
    const selectedCode = e.target.value;
    const selectedDept = deptList.find(d => d.dept_code === selectedCode);
    setForm({
      ...form,
      parent_dept_code: selectedCode,
      parent_dept_name: selectedDept?.dept_name || '',
    });
  };

  const handleSubmit = async () => {
    await updateDept(code, form, comCode);
    alert('수정 완료');
    if (onUpdated) {
      onUpdated(); // ✅ 부모에게 갱신 요청
    } else {
      onCancel();
    }
  };



  return (
    <div>
      <h3>{comName ? `${comName} | ` : ''}✏️ 부서 수정</h3>

      <input
        className="form-control mb-2"
        name="dept_name"
        value={form.dept_name}
        onChange={handleChange}
        placeholder="부서명"
      />

      <select className="form-select mb-2" value={form.parent_dept_code} onChange={handleParentChange}>
        <option value="">상위 부서 선택</option>
        {deptList.map(dept => (
          <option key={dept.dept_code} value={dept.dept_code}>
            {dept.dept_name} ({dept.dept_code})
          </option>
        ))}
      </select>
      <input
        type="number"
        className="form-control mb-2"
        name="sort_order"
        value={form.sort_order}
        onChange={handleChange}
        placeholder="정렬 순서 (숫자)"
      />

      <input
        className="form-control mb-2"
        name="manager_userid"
        value={form.manager_userid}
        onChange={handleChange}
        placeholder="담당자 ID"
      />

      <button className="btn btn-success" onClick={handleSubmit}>저장</button>
      <button className="btn btn-secondary ms-2" onClick={onCancel}>취소</button>
    </div>
  );
}

export default DeptEdit;